export const inputCls = "w-full bg-[#FBF5F1] border border-[rgba(61,50,56,0.12)] rounded-lg px-3 py-2.5 text-sm text-[#3D3238] focus:border-[#C6899E] focus:outline-none transition-colors";
export const labelCls = "block text-xs uppercase tracking-[0.12em] text-[#9C8F94] mb-1.5";

export function Field({ label, children }) {
  return (
    <div>
      {label && <label className={labelCls}>{label}</label>}
      {children}
    </div>
  );
}

export function Toggle({ label, checked, onChange, testid }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} data-testid={testid}
      className="flex items-center gap-3 text-sm text-[#3D3238]">
      <span className={`w-10 h-6 rounded-full transition-colors relative ${checked ? "bg-[#C6899E]" : "bg-[#E9DBD3]"}`}>
        <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-transform ${checked ? "translate-x-4" : "translate-x-0.5"}`} />
      </span>
      {label}
    </button>
  );
}
